import { render, staticRenderFns } from "./ShapeDivider.vue?vue&type=template&id=ab5b4f84&scoped=true"
import script from "./ShapeDivider.vue?vue&type=script&lang=js"
export * from "./ShapeDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5b4f84",
  null
  
)

export default component.exports